import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { Pergunta } from 'api/Assessor/duvidas';
import { DialogIcon } from 'components/Icons';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import Question from './Duvida';
import Responder from './Responder';
import ChatContext from './ChatContext';
import useStyle from './style';

export default function () {
  const { t } = useTranslation();
  const classes = useStyle();
  const { conversaAtual } = useContext(MensagensContext);
  const [duvidaAtual, setDuvida] = useState<Pergunta>();

  const updateDuvida = useCallback(
    (changes: object) => {
      if (duvidaAtual) {
        const _duvida = Object.assign({}, duvidaAtual, changes);
        setDuvida(_duvida);
      }
    },
    [duvidaAtual]
  );

  useEffect(() => {
    if (conversaAtual && duvidaAtual) {
      const same = conversaAtual.perguntas.find(
        pergunta => pergunta.idPergunta === duvidaAtual.idPergunta
      );
      !same && setDuvida(undefined);
    }
  }, [conversaAtual, duvidaAtual]);

  const NenhumaConversa: React.FC = () => (
    <div className={classes.noChat}>
      <DialogIcon />
      <Typography>{t('AssessorMensagens.nenhuma-conversa')}</Typography>
    </div>
  );

  return (
    <ChatContext.Provider
      value={{
        duvidaAtual,
        setDuvida,
        updateDuvida,
      }}
    >
      <Grid item component="section" className={classes.root}>
        {!conversaAtual ? (
          <NenhumaConversa />
        ) : (
          <React.Fragment>
            <div className={classes.conversa}>
              {Array.from(conversaAtual.perguntas).map(duvida => (
                <Question key={duvida.idPergunta} {...duvida} />
              ))}
            </div>
            <Responder />
          </React.Fragment>
        )}
      </Grid>
    </ChatContext.Provider>
  );
}
